import { render, staticRenderFns } from "./AcessarDocumentosPedidoBtnMaisAcoes.vue?vue&type=template&id=06fe3d52&scoped=true"
import script from "./AcessarDocumentosPedidoBtnMaisAcoes.vue?vue&type=script&lang=js"
export * from "./AcessarDocumentosPedidoBtnMaisAcoes.vue?vue&type=script&lang=js"
import style0 from "./AcessarDocumentosPedidoBtnMaisAcoes.vue?vue&type=style&index=0&id=06fe3d52&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fe3d52",
  null
  
)

export default component.exports